import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Main, Filter } from 'Containers';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { LoadingPage, DirtyWrapper } from 'Components';
import { submitForm, resetForm, destroyForm } from 'State/forms/actions';
import {
  BidGroupEnum,
  FilterEnum,
  CreateEditTransferEnum,
} from 'Common/FieldEnum';
import { NewEditTransferEnum } from 'Common/Constants/Enumeration/ManageTransferEnum';
import {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
} from 'State/filters/actions';
import { CREATE_EDIT_TRANSFER_FORM_NAME } from 'Common/FormEnum';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import * as FilterSelectors from 'State/filters/selectors';

import {
  saveTransfer,
  getTransferItems,
  getTransferDetail,
  clearTransferSubmitError,
  clearInvalidPreviewData,
  resetFilterOnClickOfPreviousPage,
  emptyItemList,
  clearTransferDetails,
} from '../../state/createEditTransfer/actions';
import {
  getSaveObject,
  filterDataSource,
  basicURL,
} from './../../helper/index';
import { CreateEditTransfer } from '../createEditTransfer/CreateEditTransfer';
import { PreviewTransfer } from '../createEditTransfer/PreviewTransfer';
import * as CreateEditTransferSelectors from '../../state/createEditTransfer/selectors';

class CreateTransferWizardFormContainer extends Component {
  static propTypes = {
    fetchingTransferItems: PropTypes.bool.isRequired,
    fetchingDropDown: PropTypes.bool.isRequired,
    fetchingTransferDetail: PropTypes.bool.isRequired,
    allTableStates: PropTypes.object.isRequired,
    fromSite: PropTypes.string,
    toSite: PropTypes.string,
    transferDT: PropTypes.string,
    transferItemsInfo: PropTypes.array,
    isDisabled: PropTypes.bool,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    selectedTransferDetail: PropTypes.object,
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    transferItemsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    fetchTransferDetailError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),

    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getTransferItems: PropTypes.func.isRequired,
    clearTransferSubmitError: PropTypes.func.isRequired,
    clearInvalidPreviewData: PropTypes.func.isRequired,
    resetFilterOnClickOfPreviousPage: PropTypes.func.isRequired,
    saveTransfer: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    destroyForm: PropTypes.func.isRequired,
    getTransferDetail: PropTypes.func.isRequired,
    emptyItemList: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    clearTransferDetails: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isDisabled: false,
    bidGroupDataError: null,
    itemGroupDataError: null,
    transferItemsLoadingError: null,
    submitError: null,
    fetchTransferDetailError: null,
    selectedTransferDetail: null,
    fromSite: '0',
    toSite: '0',
    transferDT: moment().format(DATE_FORMAT_FOR_UI),
    transferItemsInfo: [],
    submitting: false,
    submitted: false,
    loading: false,
  };
  static path = '/transfer/:IsNewEdit/:TransferId';

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      message: '',
      showNotificationModal: false,
      isPreferenceDataChange: false,
      showDateModal: false,
      resetPageOnDataChange: true,
    };
  }

  componentDidMount() {
    const { IsNewEdit, TransferId } = this.props.match.params;
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getTransferDetail,
    } = this.props;

    getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    getItemGroupForCurrentSite();
    if (IsNewEdit !== NewEditTransferEnum.NEW) {
      getTransferDetail(TransferId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      clearTransferSubmitError,
      transferItemsInfo,
      transferItemsData,
    } = this.props;
    if (
      !_.isEmpty(prevProps.transferItemsData) &&
      !_.isEmpty(transferItemsInfo) &&
      !_.isEqual(prevProps.transferItemsData, transferItemsData)
    ) {
      filterDataSource(transferItemsInfo, transferItemsData, this.props.change);
    }
    if (
      errorToast(this.props, prevProps, 'transferItemsLoadingError') ||
      errorToast(this.props, prevProps, 'fetchTransferDetailError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      clearTransferSubmitError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Transfer has been saved',
        true
      );
      clearTransferSubmitError();
    }
  }

  componentWillUnmount() {
    const {
      emptyItemList,
      clearTransferDetails,
      selectedTransferDetail,
    } = this.props;
    this.completeReset();
    emptyItemList();
    if (selectedTransferDetail) {
      clearTransferDetails();
    }
    this.clearTableSavedState();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.TRANSFER_ORDER_TABLE,
      TableNamesEnum.TRANSFER_ITEM_TABLE,
    ]);
  };

  completeReset = () => {
    this.props.resetForm(CREATE_EDIT_TRANSFER_FORM_NAME);
    this.props.destroyForm(CREATE_EDIT_TRANSFER_FORM_NAME);
  };

  hideNotificationModal = () => {
    this.setState({ showNotificationModal: false });
  };

  getRootUrl = () => {
    return '/transfer';
  };

  onPreviewTransferItemsClick = () => {
    const { fromSite, toSite } = this.props;
    if (toSite === GenericEnum.ZeroString) {
      this.setState({
        showNotificationModal: true,
        message: 'Please select a To Site.',
      });
    } else if (fromSite && toSite === fromSite) {
      this.setState({
        showNotificationModal: true,
        message:
          'The from and to sites cannot be the same. Please edit one of the selected site.',
      });
    } else {
      const { history, allTableStates, setTableStates } = this.props;
      clearTableSavedState(history, '', allTableStates, setTableStates, [
        TableNamesEnum.TRANSFER_ITEM_TABLE,
      ]);
      this.setState({
        page: this.state.page + 1,
        resetPageOnDataChange: true,
      });
    }
  };

  previousPage = () => {
    const {
      transferItemsInfo,
      clearInvalidPreviewData,
      resetFilterOnClickOfPreviousPage,
    } = this.props;
    const data = transferItemsInfo.filter(item => {
      return item.PriQty || item.SecQty;
    });
    clearInvalidPreviewData(data);
    this.setState({ page: this.state.page - 1, resetPageOnDataChange: true });
    resetFilterOnClickOfPreviousPage();
  };

  handleSave = () => {
    const transferDT = moment(this.props.transferDT);
    const currentDate = moment();
    if (transferDT > currentDate) {
      this.setState({
        showDateModal: true,
      });
    } else {
      this.props.submitForm(CREATE_EDIT_TRANSFER_FORM_NAME);
    }
  };

  handleDateChange = result => {
    this.setState({
      showDateModal: false,
    });
    if (result) {
      this.props.submitForm(CREATE_EDIT_TRANSFER_FORM_NAME);
    }
  };

  resetScroll = () => this.props.scrollMainTo(0, 0);

  handleSubmit = values => {
    const { IsNewEdit, TransferId } = this.props.match.params;
    let TransferID =
      IsNewEdit !== NewEditTransferEnum.EDIT
        ? NewEditTransferEnum.NEW
        : TransferId;
    this.props.saveTransfer(
      getSaveObject(values, TransferID, IsNewEdit),
      this.resetScroll
    );
  };

  getMainProps = showDirtyConfirm => {
    const { page } = this.state;
    const { fromSite, transferDT, transferItemsInfo, isDisabled } = this.props;
    let toolbox = {
      backButtonProps: { shown: true, path: this.getRootUrl() },
      rightButtons: [],
      shown: true,
    };
    !isDisabled &&
      (toolbox.rightButtons = [
        {
          content: 'Preview Transfer Items',
          onClick: this.onPreviewTransferItemsClick,
          disabled:
            fromSite === NewEditTransferEnum.NEW ||
            transferDT === GenericEnum.EmptyString ||
            (!transferItemsInfo || !transferItemsInfo.length),
        },
      ]);
    if (page === 2) {
      delete toolbox.backButtonProps;
      toolbox.rightButtons = [
        {
          content: 'Previous Page',
          onClick: this.previousPage,
        },
        {
          content: 'Save, Update On Hand and Close',
          onClick: this.handleSave,
          disabled: !this.isPreviewContainsValidData(),
        },
        {
          content: 'Cancel',
          onClick: showDirtyConfirm,
        },
      ];
    }
    return {
      toolbox,
    };
  };

  getBreadCrumbs = () => {
    const { page } = this.state;
    const { IsNewEdit } = this.props.match.params;

    let breadcrumbs = [
      {
        title: 'Transfer',
        link: '/transfer',
      },
      {
        title: IsNewEdit !== NewEditTransferEnum.EDIT ? 'Create New' : 'View',
        link: '',
      },
    ];
    if (page === 1) {
      breadcrumbs[1].link = '';
    }
    if (page === 2) {
      breadcrumbs.push({
        title: 'Transfers Items',
        link: '',
      });
    }
    return breadcrumbs;
  };

  onCancelClick = () => {
    this.props.history.push('/transfer');
  };

  isPreviewContainsValidData = () => {
    const { transferItemsInfo } = this.props;
    let data = [];
    if (transferItemsInfo && transferItemsInfo.length) {
      data = transferItemsInfo.filter(item => {
        return item.PriQty || item.SecQty;
      });
    }
    return Boolean(data.length);
  };

  getCreatePageAndPreviewPage = () => {
    const { page, message, showNotificationModal } = this.state;
    const { IsNewEdit, TransferId } = this.props.match.params;
    const {
      isDisabled,
      fetchingTransferItems,
      selectedTransferDetail,
      fetchTransferDetailError,
      transferItemsInfo,
      fromSiteId,
    } = this.props;
    let element = [];
    let render = false;
    let initialValues = {};
    if (IsNewEdit !== NewEditTransferEnum.NEW) {
      if (selectedTransferDetail) {
        render = true;
        initialValues = {
          [FilterEnum.GroupId_Bid]: 0,
          [FilterEnum.GroupId_Item]: 0,
          [CreateEditTransferEnum.FromSite]:
            selectedTransferDetail[CreateEditTransferEnum.FromSite],
          [CreateEditTransferEnum.ToSite]:
            selectedTransferDetail[CreateEditTransferEnum.ToSite],
          [CreateEditTransferEnum.TransferItemsInfo]: [],
          [CreateEditTransferEnum.TransferDT]: moment(
            selectedTransferDetail[CreateEditTransferEnum.TransferDT]
          ).format(DATE_FORMAT_FOR_UI),
          [CreateEditTransferEnum.Comments]:
            selectedTransferDetail[CreateEditTransferEnum.Comments],
          [CreateEditTransferEnum.TransferID]: TransferId,
          [CreateEditTransferEnum.FromSiteName]:
            selectedTransferDetail[CreateEditTransferEnum.FromSite] +
            ': ' +
            selectedTransferDetail[CreateEditTransferEnum.FromSiteName],
          [CreateEditTransferEnum.ToSiteName]:
            selectedTransferDetail[CreateEditTransferEnum.ToSite] +
            ': ' +
            selectedTransferDetail[CreateEditTransferEnum.ToSiteName],
        };
      } else if (fetchTransferDetailError) {
        render = true;
        initialValues = {
          [CreateEditTransferEnum.FromSite]: '0',
          [CreateEditTransferEnum.ToSite]: '0',
          [CreateEditTransferEnum.TransferDT]: moment().format(
            DATE_FORMAT_FOR_UI
          ),
          [CreateEditTransferEnum.Comments]: '',
          [FilterEnum.GroupId_Bid]: 0,
          [FilterEnum.GroupId_Item]: 0,
          [CreateEditTransferEnum.TransferItemsInfo]: [],
          [CreateEditTransferEnum.TransferID]: TransferId,
        };
      }
    } else {
      render = true;
      initialValues = {
        [CreateEditTransferEnum.FromSite]: '0',
        [CreateEditTransferEnum.ToSite]: '0',
        [CreateEditTransferEnum.TransferDT]: moment().format(
          DATE_FORMAT_FOR_UI
        ),
        [CreateEditTransferEnum.Comments]: '',
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [CreateEditTransferEnum.TransferItemsInfo]: [],
        [CreateEditTransferEnum.TransferID]: TransferId,
      };
    }
    if (render) {
      page === 1
        ? element.push(
            <CreateEditTransfer
              key={`newEdit${page}`}
              initialValues={initialValues}
              IsNewEdit={IsNewEdit}
              isDisabled={isDisabled}
              fetchingTransferItems={fetchingTransferItems}
              TransferId={TransferId}
              showNotificationModal={showNotificationModal}
              hideNotificationModal={this.hideNotificationModal}
              message={message}
              resetPageOnDataChange={this.state.resetPageOnDataChange}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
              setResetPageOnDataChangeValue={this.setResetPageOnDataChangeValue}
            />
          )
        : element.push(
            <PreviewTransfer
              key={`preview${page}`}
              previousPage={this.previousPage}
              initialValues={initialValues}
              onSubmit={this.handleSubmit}
              IsNewEdit={IsNewEdit}
              TransferId={TransferId}
              resetPageOnDataChange={this.state.resetPageOnDataChange}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
              transferItemsInfo={transferItemsInfo}
              fromSiteId={fromSiteId}
            />
          );
    }
    return element;
  };
  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };
  setResetPageOnDataChangeValue = resetPageOnDataChange => {
    this.setState({ resetPageOnDataChange });
  };

  render() {
    const {
      isReadOnly,
      loading,
      fetchingDropDown,
      submitting,
      fetchingTransferDetail,
    } = this.props;
    return (
      <Fragment>
        {(fetchingDropDown ||
          loading ||
          submitting ||
          fetchingTransferDetail) && <LoadingPage />}
        <Filter title={''} breadcrumbs={this.getBreadCrumbs()} />
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              {this.getCreatePageAndPreviewPage()}
            </Main>
          )}
        </DirtyWrapper>
        <YesNoDialog
          showDialog={this.state.showDateModal}
          title={'Future Date Selected'}
          question={'Future transfer date entered, are you sure Y/N?'}
          yesCallback={() => {
            this.handleDateChange(true);
          }}
          noCallback={() => {
            this.handleDateChange(false);
          }}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_TRANSFER_FORM_NAME);
const mapStateToProps = (state, props) => {
  const { IsNewEdit } = props.match.params;
  const isDisabled =
    CreateEditTransferSelectors.getSelectedTransferDetail(state) &&
    IsNewEdit === NewEditTransferEnum.EDIT;
  return {
    fromSite: selector(state, [CreateEditTransferEnum.FromSite]),
    toSite: selector(state, [CreateEditTransferEnum.ToSite]),
    transferDT: selector(state, [CreateEditTransferEnum.TransferDT]),
    transferItemsInfo: selector(state, [
      CreateEditTransferEnum.TransferItemsInfo,
    ]),
    fromSiteId: selector(state, [CreateEditTransferEnum.FromSiteID]),

    isDisabled: isDisabled,
    allTableStates: getTableStates(state),
    fetchingTransferItems: CreateEditTransferSelectors.getFetchingTransferItems(
      state
    ),
    transferItemsLoadingError: CreateEditTransferSelectors.getTransferItemsLoadingError(
      state
    ),
    submitting: CreateEditTransferSelectors.getSubmitting(state),
    submitted: CreateEditTransferSelectors.getSubmitted(state),
    submitError: CreateEditTransferSelectors.getSubmitError(state),
    loading: CreateEditTransferSelectors.getLoading(state),
    fetchingTransferDetail: CreateEditTransferSelectors.getFetchingTransferDetail(
      state
    ),
    selectedTransferDetail: CreateEditTransferSelectors.getSelectedTransferDetail(
      state
    ),
    fetchTransferDetailError: CreateEditTransferSelectors.getFetchTransferDetailError(
      state
    ),

    bidGroupDataError: FilterSelectors.getBidGroupDataError(state),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
    fetchingDropDown:
      FilterSelectors.getBidGroupDataLoading(state) ||
      FilterSelectors.getItemGroupDataLoading(state),
  };
};

const mapDispatchToProps = {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getTransferItems,
  clearTransferSubmitError,
  clearInvalidPreviewData,
  resetFilterOnClickOfPreviousPage,
  saveTransfer,
  submitForm,
  resetForm,
  destroyForm,
  getTransferDetail,
  emptyItemList,
  setTableStates,
  clearTransferDetails,
};

export const CreateTransferWizardForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTransferWizardFormContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/containers/subpages/CreateEditTransferWizardForm.js